<template>
    <div id="app">
        <NavComponent />
        <b-container style="margin-top:100px">
            <b-row>
                <b-col style="text-align:-webkit-center;">
                    <p v-if="this.data"> totalCount: {{totalCount}}</p>
                    <b-card style="display: flex;">
                        <div class="user-image-container" >
                            <div v-for="(image, index) in user.imageList " :key="index" class="user-image-list">
                                <img  class="user-image" :src="image.requestImage" /> 
                            </div>
                        </div>

                  
                        <b-card-text style="text-align:left">
                            <p v-if="data==''" style="text-align:center">
                                <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
                            </p>
                            <p v-if="this.data==null" style="text-align : center">
                                {{contentString.noList[loginCountry]}} <br>{{contentString.refresh[loginCountry]}} <br>{{countDown}}
                            </p>
                            <div v-else-if="this.data!=null">
                                <b-row class="userInfo">
                                    <b-col><strong>{{contentString.email[loginCountry]}}</strong></b-col>
                                    <b-col style="word-break: break-all">{{user.email}}</b-col>
                                </b-row>
                                <b-row class="userInfo">
                                    <b-col><strong>{{contentString.nickname[loginCountry]}}</strong></b-col>
                                    <b-col>{{user.nickName}}</b-col>
                                </b-row>
                                <b-row class="userInfo">
                                    <b-col><strong>{{contentString.country[loginCountry]}}</strong></b-col>
                                    <b-col>{{user.country}}</b-col>
                                </b-row>
                                <b-row class="userInfo">
                                    <b-col><strong>{{contentString.age[loginCountry]}}</strong></b-col>
                                    <b-col>{{user.age}}</b-col>
                                </b-row>
                                <b-row class="userInfo">
                                    <b-col><strong>성별</strong></b-col>
                                    <b-col>{{user.sex}}</b-col>
                                </b-row>
                            
                                <b-row class="userInfo">
                                    <b-col><strong>{{contentString.dateJoined[loginCountry]}}</strong></b-col>
                                    <b-col>{{user.dateJoined | moment("YYYY-MM-DD HH:mm:ss")}}</b-col>
                                </b-row>
                                <b-row class="userInfo">
                                    <b-col><strong>{{contentString.reEntrance[loginCountry]}}</strong></b-col>
                                    <b-col>{{user.reEntrance}}</b-col>
                                </b-row>
                                <b-row class="userInfo">
                                    <b-col><strong>계정 유형</strong></b-col>
                                    <b-col>{{ user.accountType }}</b-col>
                                </b-row>
                                <b-row class="userInfo">
                                    <b-col><strong>AI 평가</strong></b-col>
                                    <b-col>{{ totalAIRank }}</b-col>
                                </b-row>
                              
                            </div>
                        </b-card-text>
    
                        <b-row class="action-row-primary">
                            <b-col>
                                <b-button-group>
                                    <PermanentBanButton
                                        :userId="user.id"
                                        @ban-success="handleBanSuccess"
                                        @ban-error="handleBanError"
                                    />
                                    <ShadowBanButton
                                        :userId="user.id"
                                        @ban-success="handleBanSuccess"
                                        @ban-error="handleBanError"
                                    />
                                    <DeferButton
                                        :userId="user.id"
                                        @action-success="handleActionSuccess"
                                        @action-error="handleActionError"
                                    />
                                </b-button-group>
                            </b-col>
                        </b-row>
                        <b-row class="action-row-secondary">
                            <b-col>
                                <b-button-group>
                                    <b-button variant="outline-success" @click="updateApproval('A')" class="resultBtn" pill>A</b-button>
                                    <b-button variant="outline-success" @click="updateApproval('B')" class="resultBtn" pill>B</b-button>
                                    <b-button variant="outline-success" @click="updateApproval('C')" class="resultBtn" pill>C</b-button>
                                    <b-button variant="outline-warning" @click="updateApproval('△')" class="resultBtn" pill>△</b-button>
                                    <b-button variant="outline-danger" @click="blackTypeModalShow = !blackTypeModalShow" class="resultBtn" pill>X</b-button>
                                    <b-modal v-model="blackTypeModalShow" hide-footer hide-header style="text-align: center">
                                        <h5 style="text-align: center">
                                            {{contentString.rejectReason[loginCountry]}}
                                        </h5>
                                        <b-form-group>
                                            <b-form-checkbox-group size="sm" v-model="selected" :options="options" button-variant="outline-primary" stacked buttons style="width:100%; word-break: keep-all; word-wrap: normal;"></b-form-checkbox-group>
                                        </b-form-group>
                                        <div class="d-block text-center lg">
                                            <b-button variant="success" pill @click="blackTypeModalShow = !blackTypeModalShow, updateApprovalBlackType()" @keyup.enter="blackTypeModalShow = !blackTypeModalShow, updateApprovalBlackType()" style="margin-right:15px">
                                                {{contentString.accept[loginCountry]}}
                                            </b-button>
                                            <b-button variant="danger" pill @click="blackTypeModalShow = !blackTypeModalShow, selected = []" @keyup.esc="blackTypeModalShow = !blackTypeModalShow, selected = []" style="margin-left:15px">
                                                {{contentString.reject[loginCountry]}}
                                            </b-button>
                                        </div>
                                    </b-modal>
                                    <b-modal v-model="blackApprovalModalShow" hide-footer hide-header style="text-align: center">
                                        해당 유저를 블랙처리 하겠습니까?
                                        <div class="d-block text-center lg">
                                            <b-button variant="success" pill @click="blackApprovalModalShow = !blackApprovalModalShow, updateApproval('BLACK')" @keyup.enter="blackTypeModalShow = !blackTypeModalShow, updateApprovalBlackType()" style="margin-right:15px">
                                                {{contentString.accept[loginCountry]}}
                                            </b-button>
                                            <b-button variant="danger" pill @click="blackApprovalModalShow = !blackApprovalModalShow, selected = []" @keyup.esc="blackTypeModalShow = !blackTypeModalShow, selected = []" style="margin-left:15px">
                                                {{contentString.reject[loginCountry]}}
                                            </b-button>
                                        </div>
                                    </b-modal>
                                </b-button-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import NavComponent from './NavComponent.vue'
import ApprovalJson from '../assets/string/approval.json'
import PermanentBanButton from './PermanentBanButton.vue'
import ShadowBanButton from './ShadowBanButton.vue'
import DeferButton from './DeferButton.vue'
import { approvalPool } from '../apis/index.js'
export default {
    name: 'MaleApproval',
    components: {
        NavComponent,
        PermanentBanButton,
        ShadowBanButton,
        DeferButton
    },
    watch: {
        selected: function() {
            if (this.selected.length > 1)
                this.selected.splice(0, 1)
        },
        data: function() {
            if (this.data == null) {
                this.refreshtimer = setInterval(() => {
                    this.$router.go(0)
                    clearTimeout(this.refreshtimer)
                }, 5000)
                this.refreshCountDown()
            }
        },
        '$route.query': {
            handler() {
                this.syncRouteState()
            },
            deep: true
        },
    },
    data() {
        return {
            refreshtimer: null,
            slide: 0,
            sliding: null,
            data: '',
            poolType: approvalPool.POOL_TYPES.APPROVAL,
            user: {
                id: '',
                email: '',
                nickName: '',
                age: '',
                dateJoined: '',
                reEntrance: '',
                cash: '',
                imageList: null,
                sex: '',
                approval: '',
                country: '',
                accountType: '',
            },
            totalCount: 0,
            totalAIRank: '',
            blackTypeModalShow: false,
            blackApprovalModalShow: false,
            selected: [], // Must be an array reference!
            options: [],//ApprovalJson.inapprovalReason,
            loginCountry: this.$session.get('country'),
            selectedCountry: this.$route?.query?.country || this.$session.get('country') || 'JP',
            contentString: ApprovalJson.contentString,
            countDown: 5
        }
    },
    beforeDestroy() {
        clearTimeout(this.refreshtimer)
    },
    created() {
        this.setPoolTypeFromRoute()
        this.setCountryFromRoute()
        this.loadPoolMembers()
    },
    beforeMount() {
        let country = "description_ko"
        if(this.loginCountry == 'JP'){
            country = "description_ja"
        }
        else if(this.loginCountry == 'EN'){
            country = "description_en"
        }
        else if(this.loginCountry == 'MENA'){
            country = "description_en"
        }
        else if(this.loginCountry == 'CN'){
            country = "description_en"
        }
        this.$http.get(`${process.env.VUE_APP_API}/account/v2/inapproval-types/`, {
                headers: { 'Authorization': this.$session.get('token') },
            }).then((res) => {
                if (res.status === 200) {
                    res.data.forEach(data => {
                            this.options.push({
                                value: data.type,
                                text: data[country]
                        })
                    })
                }
            })
            .catch((err) => {
                alert(err)
            })
    },
    methods: {
        setPoolTypeFromRoute() {
            const routeType = this.$route?.query?.type
            const nextType = routeType === approvalPool.POOL_TYPES.SCAM
                ? approvalPool.POOL_TYPES.SCAM
                : approvalPool.POOL_TYPES.APPROVAL
            const hasChanged = this.poolType !== nextType
            this.poolType = nextType
            return hasChanged
        },
        setCountryFromRoute() {
            const routeCountry = this.$route?.query?.country
            const defaultCountry = this.$session.get('country') || 'JP'
            const nextCountry = (typeof routeCountry === 'string' && routeCountry.length > 0)
                ? routeCountry
                : defaultCountry
            const hasChanged = this.selectedCountry !== nextCountry
            this.selectedCountry = nextCountry
            return hasChanged
        },
        syncRouteState() {
            const typeChanged = this.setPoolTypeFromRoute()
            const countryChanged = this.setCountryFromRoute()
            if (typeChanged || countryChanged) {
                this.loadPoolMembers()
            }
        },
        buildHeaders() {
            return { 'Authorization': this.$session.get('token') }
        },
        getCountryParam() {
            const country = this.selectedCountry
            if (typeof country === 'string' && country.length > 0) {
                return country
            }
            return null
        },
        buildCountryParams() {
            const country = this.getCountryParam()
            return country ? { country } : {}
        },
        async loadPoolMembers() {
            try {
                const params = {
                    type: this.poolType,
                    ...this.buildCountryParams(),
                }
                const res = await approvalPool.fetchPoolMembers(params, this.buildHeaders())
                const members = res?.data?.data || []
                if (members.length !== 0) {
                    this.data = members
                    this.updateInfo()
                } else {
                    this.data = null
                }
            } catch (err) {
                console.error(err)
                this.data = null
                this.$toast.error(this.contentString.errorMsg[this.loginCountry], {
                    position: 'top',
                    duration: 1200
                })
            }
        },
        onSlideStart() {
            this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        },
        updateInfo() {
            this.totalCount = this.data.length
            this.user.id = this.data[0].id
            this.user.email = this.data[0].email
            this.user.nickName = this.data[0].nickname
            this.user.age = this.data[0].age
            this.user.dateJoined = this.data[0].date_joined
            this.user.reEntrance = this.data[0].reentrance
            this.user.cash = this.data[0].cash
            this.user.imageList = this.data[0].profileImages.length != 0 ? this.data[0].profileImages : [{
                id: 0,
                image: "https://storage.googleapis.com/connecting-208115.appspot.com/profileImage/2021-12-22/2021-12-22%2011%3A39%3A02%3Aec24fcc7-c2ad-4e80-a3f5-6611423801c6.png",
                requestImage: "https://storage.googleapis.com/connecting-208115.appspot.com/profileImage/2021-12-22/2021-12-22%2011%3A39%3A02%3Aec24fcc7-c2ad-4e80-a3f5-6611423801c6.png",
                approval: 0
            }]
            this.totalAIRank = this.getCalculatedAIRank(this.data[0].ai_evaluation);
            this.user.sex = this.data[0].sex
            this.user.approval = this.data[0].approval
            this.user.country = this.data[0].country
            this.user.accountType = this.data[0].account_type
            this.newNickName = ''
            this.slide = 0
        },
        async updateApproval(rank) {
            const payload = this.checkOptions(rank)
            if (!payload) {
                return
            }
            try {
                const res = await approvalPool.updateUserApproval(
                    payload,
                    this.buildCountryParams(),
                    this.buildHeaders()
                )
                if (res.status === 200 && this.data != null) {
                    this.$toast.success(this.contentString.successMsg[this.loginCountry], {
                        position: 'top',
                        duration: 1200
                    })
                } else if (this.data == null) {
                    this.$toast.warning(this.contentString.noListMsg[this.loginCountry], {
                        position: 'top',
                        duration: 1200
                    })
                }
                if (this.data.length > 1) {
                    this.data.splice(0, 1)
                    this.updateInfo()
                    this.selected = []
                } else {
                    this.data.splice(0, 1)
                    this.data = null
                    this.selected = []
                    this.wip()
                }
            } catch (err) {
                console.error(err)
                this.$toast.error(this.contentString.errorMsg[this.loginCountry], {
                    position: 'top',
                    duration: 1200
                })
            }
        },
        async updateApprovalBlackType() {
            if (this.selected.length === 0) {
                return
            }
            const payload = {
                id: this.user.id,
                approvalAction: approvalPool.APPROVAL_ACTIONS.DISAPPROVED,
                disapprovalType: this.selected[0]
            }
            const aiEvaluationId = this.data?.[0]?.ai_evaluation?.id
            if (aiEvaluationId) {
                payload.ai_evaluation_id = aiEvaluationId
            }
            try {
                const res = await approvalPool.updateUserApproval(
                    payload,
                    this.buildCountryParams(),
                    this.buildHeaders()
                )
                if (res.status === 200 && this.data != null) {
                    this.$toast.success(this.contentString.successMsg[this.loginCountry], {
                        position: 'top',
                        duration: 1200
                    })
                } else if (this.data == null) {
                    this.$toast.warning(this.contentString.noListMsg[this.loginCountry], {
                        position: 'top',
                        duration: 1200
                    })
                }
                if (this.data.length > 1) {
                    this.data.splice(0, 1)
                    this.updateInfo()
                    this.selected = []
                } else {
                    this.data.splice(0, 1)
                    this.data = null
                    this.selected = []
                    this.wip()
                }
            } catch (err) {
                console.error(err)
                this.$toast.error(this.contentString.errorMsg[this.loginCountry], {
                    position: 'top',
                    duration: 1200
                })
            }
        },
        checkOptions(rank) {
            if (!rank) {
                return null
            }
            const options = {
                id: this.user.id,
            }
            if (rank === 'BLACK') {
                options.approvalAction = approvalPool.APPROVAL_ACTIONS.SHADOW_BAN
            } else if (rank === 'DEFER') {
                options.approvalAction = approvalPool.APPROVAL_ACTIONS.DEFER
            } else if (rank === '△') {
                options.approvalAction = approvalPool.APPROVAL_ACTIONS.UNIDENTIFIED_APPROVED
            } else {
                options.profileLevel = rank
                options.approvalAction = approvalPool.APPROVAL_ACTIONS.APPROVED
            }
            const aiEvaluationId = this.data?.[0]?.ai_evaluation?.id
            if (aiEvaluationId) {
                options.ai_evaluation_id = aiEvaluationId
            }
            return options
        },
        wip() {
            this.$router.go(0)
        },
        getCalculatedAIRank(aiEvaluation) {
            try {
                if (!aiEvaluation) {
                    return "null";
                } else if (aiEvaluation.status === "FAILED") {
                    return "E";
                } else if (aiEvaluation.status === "PENDING") {
                    return "PENDING";
                } else if (aiEvaluation.ai_approval === "DISAPPROVED") {
                    return "X";
                } else if (aiEvaluation.ai_approval === "UNIDENTIFIED_APPROVED") {
                    return "△";
                } else if (aiEvaluation.ai_approval === "APPROVED") {
                    return "O";
                } else {
                    return aiEvaluation.ai_approval || "null";
                }
            } catch (e) {
                return "null";
            }
        },
        refreshCountDown() {
            setTimeout(() => {
                this.countDown--
                    setTimeout(() => {
                        this.countDown--
                            setTimeout(() => {
                                this.countDown--
                                    setTimeout(() => {
                                        this.countDown--
                                    }, 1000)
                            }, 1000)
                    }, 1000)
            }, 1000)
        },
        handleBanSuccess() {
            this.advanceQueue()
        },
        handleBanError(event) {
            // Error handling is already done in the component
            console.error("Ban failed for user:", event.userId, event.error);
        },
        handleActionSuccess() {
            this.advanceQueue()
        },
        handleActionError(event) {
            console.error("Action failed for user:", event.userId, event.error);
        },
        advanceQueue() {
            // Move to next user or refresh if no more users
            if (this.data.length > 1) {
                this.data.splice(0, 1)
                this.updateInfo()
                this.selected = []
            } else {
                this.data.splice(0, 1)
                this.data = null
                this.selected = []
                this.wip()
            }
        },
    }
}
</script>

<style scoped>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* box-sizing: content-box; */
}
.container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-image-container{
        display: flex;
        flex-direction: row;
        justify-content: center;
}

@media (max-width: 576px) {
    .user-image-container{
        display: flex;
        flex-direction: column;
    }
}  
.user-image {
    margin: 10px;
    width: 200px;
    height: 200px;
}
.resultBtn {
    margin: 5px 10px 0px 10px;
    word-break: keep-all;
    word-wrap: normal;
}
.action-row-secondary {
    margin-top: 8px;
}
.userInfo {
    border-bottom: groove;
    border-width: 1px;
    font-size: 20px;
}
</style>
